import { assertNever } from "@redotech/util/type";

export enum LogLevel {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

export type LogFn = (level: LogLevel, message: string, data?: object) => void;

export function getReturnTotalsFrontendLogFn(): LogFn {
  return (level: LogLevel, message: string, data?: object) => {
    switch (level) {
      case LogLevel.INFO:
        console.log(message, data);
        break;
      case LogLevel.WARN:
        console.warn(message, data);
        break;
      case LogLevel.ERROR:
        console.error(message, data);
        break;
      default:
        assertNever(level);
    }
  };
}
